import { obterProdutosAsync, obterProdutosPaginadosAsync } from "../../services/produtoService";

let carregamentoProdutos = null;

const atualizarProdutos = async ({ commit, state }, { forcar = false } = {}) => {
    if (!forcar && state.listaCompletaCarregada) {
        return state.produtos;
    }

    if (carregamentoProdutos) {
        return carregamentoProdutos;
    }

    carregamentoProdutos = obterProdutosAsync()
        .then((produtos) => {
            commit('atualizarProdutos', produtos);
            return produtos;
        })
        .finally(() => {
            carregamentoProdutos = null;
        });

    return carregamentoProdutos;
}

const atualizarProdutosPaginados = async ({ commit }, { pagina, tamanhoPagina, limparLista }) => {
    const resultado = await obterProdutosPaginadosAsync(pagina, tamanhoPagina);

    if (limparLista) {
        commit('limparProdutos');
    }

    commit('adicionarProdutos', resultado.itens || resultado.Itens || []);

    return {
        itens: resultado.itens || resultado.Itens || [],
        total: resultado.total || resultado.Total || 0,
        pagina: resultado.pagina || resultado.Pagina || pagina,
        tamanhoPagina: resultado.tamanhoPagina || resultado.TamanhoPagina || tamanhoPagina,
    };
}

const atualizarListaProdutos = async (context, options) => {
    await atualizarProdutos(context, options);
    return context.getters.produtosSomente;
}

const atualizarServicos = async (context, options) => {
    await atualizarProdutos(context, options);
    return context.getters.servicosExternos;
}
const atualizarServicosInterno = async (context, options) => {
    await atualizarProdutos(context, options);
    return context.getters.servicosInternos;
}

const atualizarProduto = ({ commit }, produto) => {
    commit('atualizarProduto', produto);
}

const addProduto = ({ commit }, produto) => {
    commit('addProduto', produto);
}

const updateProduto = ({ commit }, produto) => {
    commit('updateProduto', produto);
}

export default {
    atualizarProdutos,
    atualizarProdutosPaginados,
    atualizarProduto,
    addProduto,
    updateProduto,
    atualizarListaProdutos,
    atualizarServicos,
    atualizarServicosInterno
}
